/** Chaves das queries de cliente PF. Nenhuma leva CPF: só ids e filtros (a busca usa buildSearchQueryKey). */
export const physicalClientsQueryKey = ["physical-clients"] as const;

export const physicalClientDetailQueryKey = (id: number) => [...physicalClientsQueryKey, "detail", id] as const;

export const physicalClientAccessLogQueryKey = (id: number) => [...physicalClientDetailQueryKey(id), "access-log"] as const;

export const physicalClientHistoryQueryKey = (id: number) => [...physicalClientDetailQueryKey(id), "history"] as const;
